import { render } from "./PopupSub.vue?vue&type=template&id=4a4e917c"
import script from "./PopupSub.vue?vue&type=script&lang=js"
export * from "./PopupSub.vue?vue&type=script&lang=js"

import "./PopupSub.vue?vue&type=style&index=0&id=4a4e917c&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__